import { CartAddEvent } from '@theme/events';

// Redirect user to /cart when adding item
document.addEventListener(CartAddEvent.eventName, e => {
    if (e.detail.data.didError !== true && document.location.pathname !== "/cart") {
        document.location.href = "/cart"
    }
})